import React from 'react';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaLightbulb, FaCogs } from 'react-icons/fa';
// import bgImage from '../style/images/why-catapult-bg.jpg';

const features = [
  {
    icon: <FaMapMarkerAlt size={30} />,
    title: 'Venue Finalisation',
    description:
      'We scout and secure unique, undiscovered venues that perfectly match your event vision. Our network ensures you get the ideal location every time.',
  },
  {
    icon: <FaLightbulb size={30} />,
    title: 'Event Conceptualisation',
    description:
      'From invitations to decor and guest management, we co-create every detail with you for a personalized and unforgettable event journey.',
  },
  {
    icon: <FaCogs size={30} />,
    title: 'Event Production',
    description:
      'Lights, sound, crew, design, tech – we handle every production detail so you can relax and enjoy your event stress-free.',
  },
];


const WhyCatapult = () => {
  return (
     <section className="why-catapult" id="why">
      <div className="overlay"></div>
      <div className="container">
        <motion.h2
          className="why-title"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          Why Catapult Media Work?
        </motion.h2>
        <motion.p
          className="why-intro"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          Catapult Media Work is one of the most sought-after event management companies in Chennai, with 1000+ events executed. From concept to completion, we ensure your event runs smoothly while you enjoy every moment.
         <div className="section-divider" ></div>
        </motion.p>
        <div className="why-grid">
          {features.map((item, index) => (
            <motion.div
              className="why-card"
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 * (index + 1) }}
              viewport={{ once: true }}
            >
              <div className="icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default WhyCatapult